import { vsComponentName as masterAgreementDetailComponentName } from "./components/types/gamingContractMasterAgreement/detail";
import { vsComponentName as gamingContractDetailComponentName } from "./components/types/gamingContract/detail";
import { vsObjectName as gamingContractName } from "./configs/gamingContract";
import { vsObjectName as gamingContractMasterAgreementName } from "./configs/gamingContractMasterAgreement";
import {
  ContractServiceProvider,
  vsProviderName as contractServiceProviderName,
} from "../../../Contract/shared/ContractService";

import {
  getContractMachineTab,
  getContractTabForMachineDetailAuthorizedUiElementConfig,
} from "../../../Contract/shared/configs/helpers";
import { infoState } from "../../../Contract/shared/ContractService";
import { Contract } from "../../../Contract/shared/model/contract";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { ServiceResponse } from "../../../records/server/query";
import { vsObjectName as masterAgreementAmendmentName } from "./configs/gamingContractMasterAgreementAmendment";
import { ChangeJournalObject } from "../../../records/changeJournal/changeJournalViewComponent/models";
import { getContractAmendmentTab } from "../../../Contract/shared/configs/helpers";
import { AuthorizedUiElementConfig } from "../../../ui/authorizedUiElement";
import { StateProvider } from "@uirouter/angularjs";
const sensitiveInfoPermission = "contractSensitiveInfo";

registerContracts.$inject = [contractServiceProviderName];
export function registerContracts(
  contractServiceProvider: ContractServiceProvider,
) {
  contractServiceProvider.addContractType({
    id: gamingContractName,
    name: "Gaming Contract",
    detailComponentName: gamingContractDetailComponentName,
    formConfigName: gamingContractName,
    gridConfigName: gamingContractName,
    objectName: "GamingContract",
    sensitiveInfoPermission,
    tabs: [
      getContractMachineTab({
        contractTypeId: gamingContractName,
        gridViewSymbolKey: "gamingContractMachines",
        gridEditSymbolKey: "gamingContractMachines.edit",
        machineInfoState: "main.machines.machine.configurations",
      }),
    ],
    prepareClone(model) {
      return model;
    },
  });

  const amendmentBaseState = `${infoState}.amendments`;

  contractServiceProvider.addContractType({
    id: gamingContractMasterAgreementName,
    name: "Master Agreement",
    detailComponentName: masterAgreementDetailComponentName,
    formConfigName: gamingContractMasterAgreementName,
    gridConfigName: gamingContractMasterAgreementName,
    objectName: "GamingContractMasterAgreement",
    sensitiveInfoPermission,
    resolveAdditionalChangeJournalObjects: [
      "contract",
      ServerUtilityName,
      (contract: Contract, serverUtility: ServerUtility) =>
        getContractAmendments(serverUtility, contract).then((amendments) =>
          amendments.map(
            (a) =>
              <ChangeJournalObject>{
                id: {
                  ObjectId: a.Id,
                  ObjectName: masterAgreementAmendmentName,
                },
                object: a,
              },
          ),
        ),
    ],
    tabs: [
      getContractAmendmentTab({
        amendmentObjectName: masterAgreementAmendmentName,
        apiBaseUrl: "/api/contract/masterAgreement",
        parentIdProperty: "GamingContractMasterAgreementId",
        title: "Master Agreement Amendments",
        detailComponent: "masterAgreement",
      }),
    ],
  });
}

function getContractAmendments(
  serverUtility: ServerUtility,
  contract: Contract,
) {
  return serverUtility
    .sendApiRequest<ServiceResponse<any[]>>({
      url: `/api/contract/masterAgreement/${contract.Id}/amendments`,
      method: "get",
    })
    .then((response) => response.Result);
}

registerMachineDetailGamingContractTab.$inject = ["$stateProvider"];
export function registerMachineDetailGamingContractTab(
  $stateProvider: StateProvider,
) {
  const contractTab = getContractTabForMachineDetailAuthorizedUiElementConfig({
    displayName: "Gaming Contracts",
    id: "gamingContracts",
    uiSrefFragment: "gamingContract",
    contractTypeId: gamingContractName,
    gridViewSymbolKey: "machineGamingContracts",
    gridEditSymbolKey: "machines.gamingContract.edit",
  });

  registerStates(contractTab, $stateProvider, "main.machines.machine");
}

function registerStates(
  uiElement: AuthorizedUiElementConfig,
  $stateProvider: StateProvider,
  parentStateName: string,
) {
  const stateDefinition = uiElement.stateDefinition!;
  const stateName = `${parentStateName}.${uiElement.uiSrefFragment}`;
  $stateProvider.state(stateName, stateDefinition);
  uiElement.children?.forEach((c) => {
    registerStates(c, $stateProvider, stateName);
  });
}
